module.exports = {"440607001":"西南街道","440607004":"云东海街道","440607101":"大塘镇","440607103":"乐平镇","440607104":"白坭镇","440607105":"芦苞镇","440607106":"南山镇","440607400":"省三水劳教所","440607401":"省南丰劳教所","440607402":"省女子劳教所","440607403":"省第二戒毒劳教所","440607404":"广州军区三水农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440607.json
// module id = 1814
// module chunks = 0